import React from "react";
import Login from "../../components/login/Login";

const LoginPage = () => {
  return (
    <div>
      <Login />
    </div>
  );
};

export default LoginPage;
